import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Tooltip } from "common-components/Tooltip";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel as AccordionPanel,
  AccordionItemState
} from "react-accessible-accordion";
import { convertStringToElements } from "@vds/html-parsers";

import { media } from "utils/style";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";

//gg
import { decryptData } from "utils/decryptData";
//end of gg

class LandingPageAccordion extends Component {
  truncate = text => {
    return text;
    //return text && text.length > 80 ? `${text.substring(0, 80)}...` : text || null;
  };

  handleChange = data => {
    if (data && data[0]) {
      this.props.fetchExtendedPreview(data[0]);

      const element = document.activeElement;
      const offset = 125;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
  };

  render() {
    const hasNoDataElement = this.props.topLevelCategories.find(item => item.category_id === "nodata");
    return (
      <Accordion className="main_accordion accordianContainer" allowZeroExpanded onChange={this.handleChange}>
        {this.props.topLevelCategories.map(
          item =>
            item.category_id !== "nodata" && (
              <AccordionItem key={item.category_id} uuid={item.category_id}>
                <AccordionItemHeading >
                  <AccordionItemButton>
                    <TopLevelHeader>{item.category_name}</TopLevelHeader>
                    <AccordionItemState>
                      {state => {
                        if (state.expanded) {
                          return <Span aria-hidden="true" style={{ marginBottom: "5px" }}>{item.category_description}</Span>;
                        }
                        return <Span className="subText">{this.truncate(item.category_description)}</Span>;
                      }}
                    </AccordionItemState>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemState>
                  {({ expanded }) => {
                    if (expanded) {
                      if (this.props.loading) {
                        return <RectangleLoader style={{ padding: "0" }} />;
                      }
                      return (
                        <Fragment>
                          {item.category_sub_description ? (
                            <CategorySubDescription>
                              {convertStringToElements(item.category_sub_description)}
                            </CategorySubDescription>
                          ) : null}

                          <AccordionItemPanel
                            className={
                              this.props.subLevelCategories.length ? "accordion__panel" : "noDataAvailable"
                            }
                          >
                            <Accordion className="sub_accordion subAccordianContainer" allowZeroExpanded allowMultipleExpanded>
                              {this.props.subLevelCategories.length ? (
                                this.props.subLevelCategories.map(item => (
                                  <AccordionItem key={item.header}>
                                    <AccordionItemHeading aria-level="4">
                                      <AccordionItemButton className="sub_accordion_button">
                                        <SubLevelHeader>{item.header}</SubLevelHeader>
                                        <SubLevelHeaderDesc>
                                          {convertStringToElements(item.description)}
                                        </SubLevelHeaderDesc>
                                      </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <Fragment>
                                      <AccordionItemState>
                                        {({ expanded }) =>
                                          item.subdescription &&
                                          expanded && (
                                            <SubCategoryDescription>
                                              {item.header !== "HUM" ?
                                                <>
                                                  {convertStringToElements(item.subdescription)}
                                                </>
                                                : null}
                                            </SubCategoryDescription>
                                          )
                                        }
                                      </AccordionItemState>
                                      <AccordionItemPanel className="sub_accordion_panel">
                                        {item.attributes.map(content => (
                                          <Fragment key={content.attrName}>
                                            <SubAccordionPanel>
                                              <SubLevelHeader>{content.attrName}</SubLevelHeader>
                                              {content.attrValue.map(value => (
                                                <PanelContent key={value}>
                                                  <P>{decryptData(value)}</P>
                                                  {content.tooltip_information && (
                                                    <Tooltip>
                                                      {convertStringToElements(content.tooltip_information)}
                                                    </Tooltip>
                                                  )}
                                                </PanelContent>
                                              ))}
                                            </SubAccordionPanel>
                                          </Fragment>
                                        ))}
                                      </AccordionItemPanel>
                                    </Fragment>
                                  </AccordionItem>
                                ))
                              ) : this.props.error ? (
                                <p>{this.props.error}</p>
                              ) : (
                                <p>
                                  {(hasNoDataElement && hasNoDataElement.category_description) ||
                                    "We don't have this information about you for this category."}
                                </p>
                              )}
                            </Accordion>
                          </AccordionItemPanel>
                        </Fragment>
                      );
                    }
                  }}
                </AccordionItemState>
              </AccordionItem>
            )
        )}
      </Accordion>
    );
  }
}

LandingPageAccordion.propTypes = {
  fetchExtendedPreview: PropTypes.func.isRequired,
  topLevelCategories: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  subLevelCategories: PropTypes.array.isRequired
};

export default LandingPageAccordion;

const SubCategoryDescription = styled.div`
  max-width: 609px;
  margin-top: 5px;
  margin-bottom: 25px;

  p {
    margin: 20px 0;
  }

  p:first-of-type {
    margin-top: 0;
  }

  ${media.mobile`
    max-width: 90%;
    font-size: 12px;
    margin-top: 5px;
    margin-bottom: 15px;
    
    p {
      margin: 15px 0;
    }
    p:first-of-type {
      margin-top: 0;
    }
  `}
`;

const PanelContent = styled.div`
  display: flex;
  width: 45%;

  ${media.mobile`
    width: 100%;
  `}
`;

const AccordionItemPanel = styled(AccordionPanel)`
  &.noDataAvailable {
    padding: 10px 0 24px 0;
  }
`;

const SubLevelHeaderDesc = styled.span`
  max-width: 609px;
  display: inline-block;

  ${media.mobile`
    display: inline-block;
    font-size: 12px;
    max-width: 90%;
  `}
`;

const TopLevelHeader = styled.span`
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 5px;

  ${media.mobile`
    display: inline-block;
    max-width: 90%;
    font-size: 16px;
    margin-bottom: 0;
  `};
`;

const Span = styled.span`
  margin-top: 8px;
  display: block;
  max-width: 526px;
  font-family: 'Verizon-NHG-eDS', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: 0.5px;
  color:#6F7171
  

  ${media.mobile`
    font-size: 12px;
    line-height: 14px;
    max-width: 90%;
  `};
`;

const CategorySubDescription = styled.p`
  max-width: 525px;
  margin: 5px 0 25px 0;

  ${media.tablet`
    width: 75%;
  `};

  ${media.mobile`
    width: 90%;
  `};
`;

const SubLevelHeader = styled.span`
  display: block;
  flex: 1;
  max-width: 55%;
  font-family: "Verizon-NHG-eDS", Helvetica, Arial, sans-serif;
  font-weight: 700;

  ${media.tablet`
    max-width: 50%;
  `}

  ${media.mobile`
    font-size: 14px !important;
    max-width: 100%;
    margin-bottom: 4px;
  `};
`;

const SubAccordionPanel = styled.div`
  width: 75%;
  margin: 15px 0 0 auto;
  display: flex;

  ${media.tablet`
    width: 90%;  
  `}

  ${media.mobile`
    width: 100%;
    display: inherit;
  `};
`;

const P = styled.p`
  padding-right: 15px;

  ${media.mobile`
    font-size: 12px !important;
    text-align: left;    
  `};
`;
